import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$: Observable<boolean> = this.loadingSubject.asObservable();

  private activeRequests = 0;

  showLoading(): void {
    this.activeRequests++;
    // Si es la primera petición, mostramos el loading
    if (this.activeRequests === 1) {
      this.loadingSubject.next(true);
    }
  }

  hideLoading(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }
    // Solo ocultamos el loading cuando no queden peticiones activas
    if (this.activeRequests === 0) {
      this.loadingSubject.next(false);
    }
  }
}
